// import store from './../store';

import {
	Tool
} from "./Tool.js";
import {
	getDeviceTypeName
} from './nativeOtherOperate.js'

import JsBridge from "./JsBridge"

// import {
// 	UPDATE_LOAD_SHOW
// } from "./../store/types.js";

// 封装请求
import {
	GET,
	SEALP,
} from './http';

// import {
// 	Toast
// } from 'vant'
// Vue.use(Toast)

var canNotify = false
var requestId = ''
var tmpData = null
var tool = null
let metaInfo = null
let faceResult = null
let token = ''


function getCurrentTools() {
	if (!tool) {
		tool = Tool.getTools()
	}
	if (!tool) {
		return true
	}
	return false
}


//ios版本初始化实人认证sdk
export function initIosAuth() {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			tool.initVerify()
			break;
		case 'Harmony':
			break;
		case 'Android':
			break;
		case 'iOS':
			break;
		default:

			break;
	}
}

//data 必须数据
//data.type 0实人认证，1法人实人认证  2活体认证 3扫码认证
//调用实体认证和活体认证
export function realLiveAuth(data) {
	if (!data) {
		realLiveAuthFaild('调用认证失败，请重试！')
		return
	}
	tmpData = data
	console.log('tmpData---=', tmpData)
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				realLiveAuthFaild('调用认证失败，请重试！')
				return
			}
			faceResult = plus.android.implements("com.uniapp.pcitc.esign.MyFaceResult", {
				"setResult": function (status, result) {
					//验证完成回调
					realLiveAuthResult(result)
					// if (canNotify) {
					// 	pushAuthResult(status, result)
					// }
				}
			})
			if (!faceResult) {
				realLiveAuthFaild('调用认证失败，请重试！')
				return
			}
			metaInfo = tool.getMetaInfo(plus.android.runtimeMainActivity())
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				realLiveAuthFaild('调用认证失败，请重试！')
				return
			}
			if (plus.os.name === 'iOS') {
				faceResult = plus.ios.implements("MyFaceResult", {
					"setResult:": function (result) {
						console.log('reuslt', result)
						//验证完成回调
						realLiveAuthResult(result)
						// if (canNotify) {
						// 	let status = (result === '刷脸成功') ? 1 : 0
						// 	console.log('reuslt',status)
						// 	pushAuthResult(status, result)
						// }
					}
				})
				if (!faceResult) {
					realLiveAuthFaild('调用认证失败，请重试！')
					return
				}
				metaInfo = tool.getMetaInfo()
			}
			break;
		case 'Harmony':
			metaInfo = harmonyEsign.getMetaInfo()
			break;
		case 'Android':
			console.log('adnroid-realLiveAuth', window.WebViewJavascriptBridge, JsBridge)
			//metaInfo = window.WebViewJavascriptBridge.getMetaInfo()
			JsBridge.callHandler(
				'getMetaInfo', {},
				function (responseData) {
					//todo设置metaInfo 调用getAppToken
					console.log('-WebViewJavascriptBridge-getMetaInfo', responseData)
					metaInfo = responseData
					if (!metaInfo) {
						realLiveAuthFaild('调用认证失败，请重试！')
						return
					}
					getAppToken(data)
				}
			)
			break;
		case 'iOS':
			JsBridge.callHandler(
				'getMetaInfo', {},
				function (responseData) {
					//todo设置metaInfo 调用getAppToken
					console.log('-WebViewJavascriptBridge-getMetaInfo', responseData)
					metaInfo = responseData
					if (!metaInfo) {
						realLiveAuthFaild('调用认证失败，请重试！')
						return
					}
					getAppToken(data)
				}
			)
			break;
		default:
			realLiveAuthFaild('该设备不支持实人认证，请使用手持可用设备！')
			break;
	}
	if (getDeviceTypeName() !== 'Android' && getDeviceTypeName() !== 'iOS') {
		if (!metaInfo) {
			realLiveAuthFaild('调用认证失败，请重试！')
			return
		}
		getAppToken(data)
	}
}

//获取esstoken
function getAppToken(data) {
	GET('/seal/api/genAppToken', {
		appCode: ''
	}).then((res) => {
		if (res.success && res.data) {
			token = res.data
			getCertifyId(data, res.data)
		} else {
			realLiveAuthFaild(res.message || res.messageDetail)
		}
	}).catch((err) => {
		realLiveAuthFaild(err.message || '调用认证失败，请重试！')
	});
}

//获取certifyId
function getCertifyId(data, token) {
	let url = ''
	let obj = null
	switch (data.type) {
		case '0':
			url = '/face/api/initActualVerify/person?token=' + token
			obj = {
				staffName: data.staffName,
				idCardNo: data.idCode,
				metaInfo: metaInfo,
			}
			// url = '/face/api/initActualVerify/staff?token=' + token
			// obj = {
			// 	staffId: data.staffId,
			// 	metaInfo: metaInfo,
			// }
			break;
		case '1':
			url = '/face/api/initActualVerify/person?token=' + token
			obj = {
				staffName: data.legalName,
				idCardNo: data.legalCode,
				metaInfo: metaInfo,
			}
			break;
		case '2':
			url = '/face/api/initLivingVerify/staff?token=' + token
			obj = {
				staffId: data.staffId,
				//corpId: data.corpId,
				metaInfo: metaInfo,
			}
			break;
		case '3':
			url = '/face/api/initVerify?token=' + token
			obj = {
				requestId: data.requestId,
				metaInfo: metaInfo,
			}
			break;
	}
	SEALP(url, JSON.stringify(obj)).then((res) => {
		if (res.success && res.data) {
			canNotify = res.data.canNotify
			requestId = res.data.requestId
			//console.log('getCertifyId', window.location)
			// if (process.env.NODE_ENV === 'development' || window.location.origin.indexOf('test') !== -1) {
			// 	realLiveAuthResult('认证成功！')
			// } else {
			// 	verifySwitch(res.data.certifyId, faceResult)
			// }
			verifySwitch(res.data.certifyId, faceResult)
		} else {
			realLiveAuthFaild(res.message || res.messageDetail)
		}
	}).catch((err) => {
		realLiveAuthFaild(err.message || '调用认证失败，请重试！')
	});
}

//实人认证调用环境判断
function verifySwitch(certifyId, faceResult) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			tool.verify(plus.android.runtimeMainActivity(), certifyId, faceResult)
			break;
		case 'plusiOS':
			tool.verify(certifyId, faceResult)
			break;
		case 'Harmony':
			harmonyEsign.verify(certifyId).then(res => {
				realLiveAuthResult(res)
			}).catch(err => {
				if (canNotify) {
					realLiveAuthResult(err)
				} else {
					realLiveAuthFaild(err || '调用认证失败，请重试！')
				}
			})
			break;
		case 'Android':
			window.WebViewJavascriptBridge.callHandler(
				'faceVerify', {
				'certifyId': certifyId
			},
				function (responseData) {
					//console.log('-WebViewJavascriptBridge-faceVerify', responseData)
					//todo判断结果
					let result = JSON.parse(responseData)
					if (result.flag) {
						realLiveAuthResult('认证成功！')
					} else {
						realLiveAuthResult(result.message)
					}
				}
			)
			break;
		case 'iOS':
			JsBridge.callHandler(
				'faceVerify', {
				'certifyId': certifyId
			},
				function (responseData) {
					console.log('-WebViewJavascriptBridge-faceVerify', responseData)
					if (responseData.flag) {
						realLiveAuthResult('认证成功！')
					} else {
						realLiveAuthResult(responseData.message)
					}
				}
			)
			break;
		default:
			break;
	}
};

//认证结果查询
function realLiveAuthResult(result) {
	SEALP('/face/api/describeVerify?token=' + token + '&requestId=' + requestId, {}).then((res) => {
		if (res.success && res.data) {
			if (res.data.passed) {
				if (canNotify) {
					pushAuthResult(true, result instanceof String ? result : '认证成功！', '认证成功！')
				} else {
					realLiveAuthSucced()
				}
			} else {
				if (canNotify) {
					pushAuthResult(false, result instanceof String ? result : '认证失败', '认证未通过！')
				} else {
					realLiveAuthFaild('认证未通过！')
				}
			}
		} else {
			if (canNotify) {
				pushAuthResult(false, result instanceof String ? result : '认证失败', res.message || res
					.messageDetail)
			} else {
				realLiveAuthFaild(res.message || res.messageDetail)
			}
		}
	});
};

//认证结果成功回调
function realLiveAuthSucced() {
	//console.log('tmpData---=',tmpData)
	switch (tmpData.type) {
		case '0':
			faceAuthSucced(requestId)
			break;
		case '1':
			legalFaceAuthSucced(requestId)
			break;
		case '2':
			faceCompareAuthSucced(requestId)
			break;
		case '3':
			scanAuthSucced()
			break;
	}
}

//认证结果失败回调
function realLiveAuthFaild(msg) {
	//console.log('tmpData---=',tmpData)
	switch (tmpData.type) {
		case '0':
			faceAuthFaild(msg)
			break;
		case '1':
			legalFaceAuthFailed(msg)
			break;
		case '2':
			faceCompareAuthFailed(msg)
			break;
		case '3':
			scanAuthFailed(msg)
			break;
	}
}

//上传实人认证结果
function pushAuthResult(succed, message, backMessage) {
	SEALP('/face/api/notifyVerify?token=' + token, JSON.stringify({
		"requestId": requestId,
		"succeed": succed,
		"message": message
	})).then(res => {
		if (succed) {
			realLiveAuthSucced()
		} else {
			realLiveAuthFaild(backMessage)
		}
	}).catch(err => {
		realLiveAuthFaild(backMessage)
	})
}